import SliderControls from '@components/common/SliderControls'
import {
  COLOUR_CARD_METAFIELD_KEY,
  findMetafieldValueByKey,
} from '@lib/helpers/general'
import {
  RecentlyViewedProduct,
  useRecentlyViewedProducts,
} from '@lib/hooks/useRecentlyViewedProducts'
import 'keen-slider/keen-slider.min.css'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useRef } from 'react'
import Slider from 'react-slick'
import { useWindowSize } from 'usehooks-ts'
import { ProductCard } from '..'
import { ProductCardMode } from '../ProductCard/ProductCard'
const RecentlyViewedProducts = () => {
  const { t } = useTranslation('common')
  const { locale } = useRouter()
  const { recentlyViewed } = useRecentlyViewedProducts(locale!)
  const { width } = useWindowSize()
  const slider = useRef<any | null>(null)
  const slidesLength = recentlyViewed?.length || 0
  const slidesToShow = width > 1024 ? 4 : width > 600 ? 3 : 1
  const infinite = slidesLength > slidesToShow
  const settings = {
    autoplay: false,
    speed: 300,
    arrows: false,
    centerMode: false,
    accessibility: true,
    infinite: infinite,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    draggable: true,
  }

  const onPrev = () => {
    slider.current?.slickPrev()
  }
  const onNext = () => {
    slider.current?.slickNext()
  }
  const shouldShowSliderControls = () => {
    if (width > 1024) {
      return recentlyViewed.length > 4
    } else if (width > 600) {
      return recentlyViewed.length > 3
    } else {
      return recentlyViewed.length > 1
    }
  }
  if (recentlyViewed.length === 0) return null
  return (
    <div className=" bg-white py-16">
      <div className="wrapper flex flex-col gap-y-10">
        <div className="heading-3">{t('you-recently-viewed')}</div>
        <div className="relative -mx-4">
          <Slider ref={slider} {...settings} className="bwk-rvp-slider">
            {recentlyViewed?.map(
              (product: RecentlyViewedProduct, index: number) => {
                const colourCardHandle = findMetafieldValueByKey(
                  product?.metafields!,
                  COLOUR_CARD_METAFIELD_KEY
                )
                return (
                  <div key={`slider-${index}`} className="box-border px-4">
                    <ProductCard
                      key={`slider-${index}`}
                      id={product.id}
                      mode={ProductCardMode.COLOUR}
                      path={product.path}
                      handle={product.handle}
                      name={product.name}
                      colourCode={product?.colourCode}
                      imageUrl={product?.images[0]?.url}
                      imageAlt={product?.images[0]?.alt}
                      type={product.productType}
                      popular={false}
                      classNames="keen-slider__slide"
                      showQuickAddButton
                      showWishListButton
                      colourCardHandle={colourCardHandle!}
                    />
                  </div>
                )
              }
            )}
          </Slider>
          {slider && shouldShowSliderControls() && (
            <SliderControls onPrev={onPrev} onNext={onNext} />
          )}
        </div>
      </div>
      <style jsx global>
        {`
          .bwk-rvp-slider .slick-track {
            margin-left: 0 !important;
            margin-right: auto !important;
          }
        `}
      </style>
    </div>
  )
}

export default RecentlyViewedProducts
